module.exports = __webpack_public_path__ + "static/img/model-bg3.17d13c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg3.jpg
// module id = c065
// module chunks = 0